type ScrollArrowProps = {
  href: string
  label: string
}

export function ScrollArrow({ href, label }: ScrollArrowProps) {
  return (
    <div className="absolute bottom-[50px] left-0 block w-full">
      <a
        href={href}
        aria-label={label}
        className="grid h-full min-h-[50px] w-full place-content-center hover:cursor-pointer"
      >
        <span className="h-[3rem] w-[3rem] [animation:scroll-bounce_500ms_ease-out_alternate_infinite]">
          <span className="block h-[3rem] w-[3rem] rotate-45 border-[3px] border-white border-t-0 border-l-0 opacity-50" />
        </span>
      </a>
    </div>
  )
}

export default ScrollArrow
